module.exports = __webpack_public_path__ + "d5ee9166c2aa6f28bbac4ddc98f61141.svg";